import React, { useState } from "react";
import ConductReviewsTable from "./ConductReviewsTable";
import ReviewHistoryTable from "./ReviewHistoryTable";
import HeaderComponent from "components/card/HeaderComponent";
import Card from "components/card";
import SearchBar from "components/search/SearchBar";
import SelectOption from "components/select/SelectOption";
import CustomTabs from "components/tabs/customTab";
import { Calendar, FileText } from "lucide-react";

export default function TrainingProgramTabs()  {
  const [activeTab, setActiveTab] = useState("conduct-reviews");
  
  const TabLabel = ({ icon: Icon, text }) => (
    <div className="flex items-center justify-center gap-2">
        <Icon className="text-gray-800 w-4 h-4" />
        <span className="text-sm font-medium">{text}</span>
    </div>
  );

  const tabOptions = [
    { label: <TabLabel text="Conduct Reviews" icon={FileText} />, value: "conduct-reviews" },
    { label: <TabLabel text="Review History" icon={Calendar} />, value: "review-history" },
  ];

  return (
    <div>

      <CustomTabs
        tabs={tabOptions}
        activeTab={activeTab}
        onChange={setActiveTab}
        height="h-10"
      />

      <div className="space-y-6 mt-6 ">
        {activeTab === "conduct-reviews" && (
          <div>
          <div >
            <Card extra="flex p-6">
              <div className="gap-2 grid grid-cols-1 md:grid-cols-3">
                <SearchBar
                  placeholder="Search employees..."
                  className="h-1" 
                />
                <SelectOption
                    placeholder="All Department"
                    options={[
                      {label:"All Department", value: 0},
                      {label:"Engineering", value: 1},
                      {label:"Marketing", value: 2},
                      {label:"HR", value: 3},
                      {label:"Finance", value: 4},
                      {label:"Design", value: 5},
                      {label:"Sales", value: 6},
                    ]}
                />
                <SelectOption
                    placeholder="All Status"
                    options={[
                      {label:"All Status", value: 0},
                      {label:"Overdue", value: 1},
                      {label:"Due", value: 2},
                      {label:"Upcoming", value: 3},
                    ]}
                />
              </div>
            </Card>
          </div>

          <Card extra="mt-5 relative max-h-[600px] p-1 overflow-y-auto">
            <ConductReviewsTable/>
          </Card>

        </div>
        )}
        {activeTab === "review-history" && (
          <div>
            <HeaderComponent
              title="Completed Reviews"
              description="View past performance reviews"
              bgcolor="white"
	          >
              <ReviewHistoryTable/>
            </HeaderComponent>

          </div>
        )}
      </div>
    </div>
  );
}
